import { FilterBar } from '@/components/filters/FilterBar';
import { SearchInput } from '@/components/filters/SearchInput';
import { DateRangePicker } from '@/components/filters/DateRangePicker';
import { Button } from '@/components/ui/Button';
import { useAdminInvoices } from '@/hooks/useAdminBilling';
import { Download } from 'lucide-react';
import { useState } from 'react';
import { MonthlyBillingTable } from '../components/MonthlyBillingTable';
import { exportToExcel } from '@/utils/export';

export function InvoicesListPage() {
  const [search, setSearch] = useState('');
  const [dateFrom, setDateFrom] = useState<string | null>(null);
  const [dateTo, setDateTo] = useState<string | null>(null);
  const { data, isLoading } = useAdminInvoices({ search, limit: 50, dateFrom: dateFrom || undefined, dateTo: dateTo || undefined });
  const invoices = data?.data || [];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div><h1 className="text-xl font-bold text-neutral-900 dark:text-neutral-100">Factures</h1><p className="text-sm text-neutral-500">{data?.pagination?.totalItems ?? 0} factures</p></div>
        <Button variant="outline" size="sm" icon={<Download className="h-4 w-4" />} onClick={() => exportToExcel(invoices, 'factures')}>Exporter</Button>
      </div>
      <FilterBar>
        <div className="w-72"><SearchInput value={search} onChange={setSearch} placeholder="Rechercher..." /></div>
        <DateRangePicker dateFrom={dateFrom} dateTo={dateTo} onChange={(f, t) => { setDateFrom(f); setDateTo(t); }} />
      </FilterBar>
      <MonthlyBillingTable data={invoices} loading={isLoading} />
    </div>
  );
}
